import { Injectable } from '@angular/core';
import { HttpClient } from "@angular/common/http";
import { BaseService } from '../../../shared/services/base.service';
import { SummaryTicketModel } from '../models/summary-ticket.model';
import { Observable } from 'rxjs';

@Injectable()
export class TicketService extends BaseService<SummaryTicketModel, SummaryTicketModel> {

  constructor(http: HttpClient) {
    super(http, '/api/v2/ticket');
  }

  export(uid: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/api/v2/ticket/${uid}/export`, {
      responseType: 'blob'
    });
  }

  getSummaryByUid(uid: string): Observable<SummaryTicketModel> {
    return this.http.get<SummaryTicketModel>(`${this.baseUrl}/api/v2/ticket/${uid}`);
  }

  getSummaryList(filters: any): Observable<any> {
    return this.http.post<any>(`${this.baseUrl}/api/v2/ticket/list`, filters);
  }
  getListFilter(activityUid: string, filter: any): Observable<any> {
    return this.http.post<any>(
      `${this.baseUrl}/api/v2/ticket/${activityUid}`,
      filter
    );
  }

}
